
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-detail",
      function () {
        return require("private-next-pages/news-detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-detail"])
      });
    }
  